module.exports = "/fonts/vendor/slick-carousel/slick/slick.eot?ced611daf7709cc778da928fec876475";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slick-carousel/slick/fonts/slick.eot
// module id = +bHc
// module chunks = 1